var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicromobility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#081754;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#081754;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "13,4.5 11.6,4.5 14.5,13  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.9,
    y1: 5.7,
    x2: 5.9,
    y2: 5.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "6.4,5.7 7.3,7.5 9.5,12.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.6,
    y1: 7.5,
    x2: 12.2,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "7.3,7.5 12.2,7.5 9.5,12.8 9.5,12.8 6.9,12.8 4.4,12.8 5.5,10.5 7.2,7.5 7.3,7.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.4,
    cy: 12.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.4,14c-0.4,0.8-1.3,1.3-2.2,1.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,8.5h1.7c0.2,0,0.4,0.1,0.4,0.3l2.5,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,18.4h5.9c0.1,0,0.3-0.1,0.4-0.2l2.1-3.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11.2,
    cy: 18.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 21.4,
    cy: 18.5,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicromobility);
export default __webpack_public_path__ + "static/media/micromobility.d18cbb3a9118d0d81956c82f068b2b16.svg";
export { ForwardRef as ReactComponent };